import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'suvo-users-card-entry',
  templateUrl: './card-entry.component.html',
  styleUrls: ['./card-entry.component.scss'],
})
export class CardEntryComponent {
  @Input() label: string;
  @Input() entryControl: FormControl | AbstractControl;
  @Input() forbidEdit = false;
  @Output() entrySaved = new EventEmitter<any>();

  @ViewChild('inputElement') set content(input: ElementRef) {
    if (input) {
      input.nativeElement.focus();
    }
  }

  editMode = false;
  beforeEditValue: any;

  finish(save: boolean) {
    if (save) {
      if (this.beforeEditValue !== this.entryControl.value) {
        this.entrySaved.emit();
      }
    } else if (this.beforeEditValue) {
      this.entryControl.setValue(this.beforeEditValue);
    }
    this.editMode = false;
  }

  edit() {
    this.beforeEditValue = this.entryControl?.value;
    this.editMode = true;
  }
}
